/* * @Author: 隔壁小王 * @Title: 首页banner组件 * @Date: 2020-10-21 14:11:47 *
@Last Modified by: knight * @Last Modified time: 2020-06-08 12:25:34 */
<template>
  <div
    class="banner-wrapper"
    v-if="banners && banners.length"
    id="cheese_banner"
  >
    <div class="banner-bg-mask"></div>

    <div
      class="banner-bg"
      :style="{ 'background-image': `url(${currentItem.img})` }"
    ></div>

    <div class="cheese_banner">
      <div
        class="banner-content"
        ref="bannerContent"
      >
        <div
          class="player-wrapper"
        >
          <div class="link">
            <transition-group name="banner-fade" tag="ul" >
              <li
                v-for="(bannerItem, index) in banners"
                :key="bannerItem.id"
                v-show="index === activeIndex"
                class="link_item"
              >
                <!-- status为1可试看 -->
                <template
                  v-if="
                    BANNER_TYPE[currentItem.type] === 'video' &&
                      currentItem.status === 1
                  "
                >
                  <div
                    class="player-innerWrapper"
                    @mouseenter="handlePlayerStart(currentItem)"
                  >
                    <div
                      class="banner-img"
                      :style="{ 'background-image': `url(${currentItem.img})` }"
                    ></div>
                    <img
                      src="../assets/images/classroom/player-pause.png"
                      alt="播放"
                      v-show="playerPlaying === 0"
                      class="player-pause"
                    />
                  </div>
                </template>

                <template v-else>
                  <div class="banner_img_wrap">
                    <span class="banner-label" v-if="currentItem.label">{{
                      currentItem.label
                    }}</span>
                    <div
                      class="banner-img"
                      :style="{ 'background-image': `url(${currentItem.img})` }"
                      @click="handleClickToStop"
                    ></div>
                    <LazyImg
                      :src="currentItem.img"
                      :alt="currentItem.title"
                      :width="978"
                      :height="550"
                      cut
                      class="banner-bg-img"
                    />
                  </div>
                </template>
              </li>
            </transition-group>

            <div
              class="player"
              v-show="playerPlaying === 1"
              @mouseenter.stop="mousestate = 1"
              @mouseleave.stop="handleMouseLeave"
            >
              <Player
                ref="webPlayer"
                :config="config"
                :playState="playState"
                :onEpisodeEnd="onEpisodeEnd"
                :inited="inited"
                :needReplay="needReplay"
                :reloadCallback="reloadCallback"
                @enterEP="jumpDetail(currentItem.link)"
              />
            </div>
          </div>
          <!-- 播放结束 -->
          <div
            class="player-finish"
            v-if="playerPlaying === 2"
            @mouseleave.stop="handleMouseLeave"
          >
            <div class="player-finish-innerWrap">
              <h6 class="player-finish-title ell">
                更多课程信息，请前往详情页查看
              </h6>
              <div class="player-finish-content">
                <div class="player-finish-innerContent">
                  <div
                    class="player-finish-btn"
                    @click="jumpDetail(currentItem.link)"
                  >
                    进入详情
                  </div>
                  <div
                    class="player-finish-btn replayed"
                    @click="handlePlayerReplay"
                  >
                    <img
                      src="../assets/images/classroom/player-replay.png"
                      alt="重播"
                      class="player-finish-replay-icon"
                    />
                    <span>重播</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner-slider-wrapper">
        <ul class="banner-slider" @mouseleave="mousestate = 0">
          <li
            v-for="(list, index) in banners"
            :key="index"
            :class="{ 'banner-item': true, active: activeIndex === index }"
            @click="handleNavClick(index)"
          >
            <h4
              :class="{
                'bannder-slider-title': true,
                ell: activeIndex !== index,
              }"
            >
              {{ list.title }}
            </h4>
            <div class="bannder-slider-status">
              <small class="banner-slider-subtitle ell">{{
                list.subtitle
              }}</small>
              <template v-if="BANNER_TYPE[list.type] === 'video'">
                <img
                  src="../assets/images/classroom/player-dynamic.gif"
                  alt="播放"
                  class="bannder-slider-icon playing"
                  v-if="playerPlaying === 1 && list.ep_id === config.episodeId"
                />
                <template v-else>
                  <img
                    src="../assets/images/player-static.png"
                    alt="播放"
                    class="bannder-slider-icon checked"
                  />
                  <img
                    src="../assets/images/player-hover.png"
                    alt="播放"
                    class="bannder-slider-icon hover"
                  />
                </template>
              </template>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import {
  BANNER_TYPE,
  SPM_ID_FROM_BANNER,
} from "../enum";
import LazyImg from 'g-public/components/CommonLazyImg';
import Player from "./Player";
import { report } from "../../public/report/index";
import { linkAppendParams, openWindowWithCsource } from "@src/public/js/convert"

export default {
  name: "banner",
  components: {
    LazyImg,
    Player,
  },
  props: {},
  data() {
    return {
      activeIndex: 0,
      BANNER_TYPE: BANNER_TYPE,
      bannerMaxDistance: 0,
      timer: null,
      player: null,
      playerPlaying: 0, // 0 未开始播放 1 开始播放 2 播放结束
      playerInit: false,
      mousestate: 0, // 0 鼠标未移入 1 鼠标移入,

      config: {},
      playState: true,
      needReplay: false,
      mouseEndFlag: true,
    };
  },
  created() {},
  mounted() {
    if (!this.$refs.bannerContent) return;
    this.bannerMaxDistance = this.$refs.bannerContent.offsetHeight * 0.2;
    this.bannerStart();
    this.setPlayerRelationHandler();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    window.removeEventListener("scroll", this.setPlayerRelationCb());
  },
  computed: {
    ...mapState(["banners", "bannersResourceId"]),
    currentItem() {
      if (this.banners && this.banners.length) {
        return this.banners[this.activeIndex];
      }

      return {
        img: "",
      };
    },
  },
  methods: {
    setPlayerRelationHandler() {
      window.addEventListener("scroll", this.setPlayerRelationCb(), false);
    },

    setPlayerRelationCb() {
      const cb = window.funcThrottle(16, false, () => {
        const react = this.$refs.bannerContent.getBoundingClientRect();
        if (react.bottom < this.bannerMaxDistance) {
          if (this.playerPlaying === 1) {
            // debug('视频停止播放');
            this.handlePlayerStop();
            this.bannerStart();
          }
        }
      });
      return cb;
    },

    bannerStart() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        // 播放状态重置为未播放
        this.playerPlaying = 0;
        this.playState = false;
        const index = this.activeIndex + 1;
        if (index >= this.banners.length) this.activeIndex = 0;
        else this.activeIndex = index;
      }, 5e3);
    },

    bannerStop() {
      clearInterval(this.timer);
    },

    setActiveIndex(index) {
      if (this.activeIndex !== index) this.activeIndex = index;
      this.bannerStart();
    },

    handleNavClick(index) {
      this.needReplay = false;
      report("banner_sidebar", { ssid: this.banners[index].season_id || '' });
      // 当前索引正在播放的不处理
      if (this.activeIndex === index && this.playerPlaying === 1) return;

      // 播放结束页立刻结束
      if (this.playerPlaying === 2) this.playerPlaying = 0;

      this.setActiveIndex(index);

      this.handlePlayerStop();
    },

    jumpDetail(url) {
      // window.open(url, "_blank");
      openWindowWithCsource(linkAppendParams(url, {
        spm_id_from: SPM_ID_FROM_BANNER
      }))
    },

    getPlayerOptions(episodeId, seasonId) {
      return {
        episodeId,
        seasonId,
      };
    },

    setPlayerConfig() {
      const { ep_id, season_id } = this.banners[this.activeIndex];
      if (ep_id === this.config.episodeId) {
        this.needReplay = true;
      } else {
        this.config = this.getPlayerOptions(ep_id, season_id);
      }
    },

    handlePlayerReplay() {
      this.$nextTick(() => {
        this.needReplay = true;
        this.bannerStop();
        this.playerPlaying = 1;
      });
    },

    reloadCallback() {
      setTimeout(() => {
        this.playerPlaying = 1;
      }, 300);
    },

    handlePlayerStart() {
      this.mousestate = 1;

      this.setPlayerConfig();
      this.playState = true;
      this.playerPlaying = 1;
      this.bannerStop();
    },

    handlePlayerStop() {
      this.playerPlaying = 0;
      this.playState = false;
    },

    handleMouseLeave() {
      this.mousestate = 0;
      if (!this.mouseEndFlag) {
        this.mouseEndFlag = true;
        return false;
      }
      if (this.playerPlaying === 2 || this.playerPlaying === 0) {
        this.bannerStart();
        return false;
      }

      return false;
    },

    handleClickToStop(e) {
      e.stopPropagation();
      e.preventDefault();
      let url = this.currentItem.link;
      // 历史场景逻辑
      const isVideoOK = BANNER_TYPE[this.currentItem.type] === "video" && this.currentItem.status === 1
      if (isVideoOK) {
        // 没有初始化完不可点击
        if (!this.playerInit) return;
        this.playerPlaying = 0;
        this.playState = false;
        this.needReplay = false;
      }
      if (window && window.BiliCm && window.BiliCm.Base) {
        window.BiliCm.Base.sendContentClickData(
          {
            resource_id: this.bannersResourceId,
            src_id: this.currentItem.src_id,
            pos_num: this.activeIndex + 1,
            id: this.currentItem.id,
            event: "web-pugvbanner_click",
          },
          this.bannersResourceId
        );
      }
      openWindowWithCsource(linkAppendParams(url, {
        spm_id_from: SPM_ID_FROM_BANNER
      }))

      return false;
    },
    onEpisodeEnd() {
      this.playerPlaying = 2;
      this.needReplay = false;
      // 鼠标未hover 自动轮播触发
      if (this.mousestate === 0) {
        this.bannerStart();
      } else {
        this.mouseEndFlag = false;
      }
    },
    inited() {
      // 播放器初始化标识
      this.playerInit = true;
      // 播放器初始化之后前台显示
      this.playerPlaying = 1;
    },
  },
};
</script>

<style lang="less">
.classroom-wrapper .bilibili-player-video-pugv-look-more:hover {
  background: #0ba395 !important;
}
</style>

<style lang="less" scoped>
.aaa {
  color: #fff;
}

.banner-wrapper {
  width: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  width: 100%;
  height: 610px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  filter: blur(26px);
}

.banner-bg-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 610px;
  background: rgba(0, 0, 0, 0.6);
}

.cheese_banner {
  width: 1286px;
  margin: 0 auto;
  /* position: absolute;
    top: 0;
    z-index: 99; */
  display: flex;
}

.banner-slider-wrapper {
  width: 308px;
  /* padding: 65px 0; */
  height: 550px;
  box-sizing: border-box;
  background: #1d1f2d;

  display: flex;
  align-items: center;
}

.banner-slider {
  width: 308px;
}

.banner-item {
  padding: 16px 30px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 20px;
  opacity: 0.6;
  color: #fff;
  cursor: pointer;
  margin: 10px 0;
  &.active {
    .bannder-slider-icon.checked {
      display: block;
    }

    .bannder-slider-icon.hover {
      display: none;
    }

    .bannder-slider-icon.playing {
      display: block;
    }
  }

  &:hover {
    opacity: 0.93;
    color: #0ba395;

    .bannder-slider-icon.hover {
      display: block;
    }

    .bannder-slider-icon.checked {
      display: none;
    }
  }

  &.active {
    opacity: 1;
    color: #fff;
    background-image: linear-gradient(
      270deg,
      rgba(11, 163, 149, 0) 0%,
      #0ba395 100%
    );

    &:hover {
      .bannder-slider-icon.hover {
        display: none;
      }

      .bannder-slider-icon.checked {
        display: block;
      }
    }
    /* .bannder-slider-title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            white-space: normal;
        } */
  }
}

.bannder-slider-title {
  width: 100%;
  /* margin-bottom: 8px; */
  /* margin-bottom: 6px; */
  max-height: 40px;
  overflow: hidden;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  word-break: break-all;
}

.banner-slider-subtitle {
  flex: 1;
  display: inline-block;
  font-size: 12px;
}

.banner-content {
  width: 978px;
  height: 550px;
  position: relative;
  z-index: 999;
}

.banner-img {
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-origin: border-box;
  background-clip: border-box;
  transition: all 0.1s;
}

.banner-bg-img {
  display: none;
  box-sizing: border-box;
}

.banner-label {
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #0ba395;
  border-radius: 3px;
  border-radius: 3px;
  position: absolute;
  left: 16px;
  top: 16px;
  color: #fff;
}

.player-innerWrapper {
  height: 550px;
  position: relative;
}

.player-showContent {
  height: 100%;
}

.player-pause {
  position: absolute;
  right: 20px;
  bottom: 10px;
  z-index: 99;
  width: 48px;
  height: 48px;
}

.player-finish {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.player-finish-innerWrap {
  position: absolute;
  z-index: 99;
  left: 50%;
  width: 290px;
  transform: translateX(-50%);
  text-align: center;
  top: 229px;
}

.player-finish-title {
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  font-weight: 500;
}

.player-finish-content {
  margin-top: 30px;
  width: 220px;

  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.player-finish-innerContent {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.player-finish-btn {
  display: inline-block;
  vertical-align: middle;
  width: 100px;
  height: 36px;
  line-height: 36px;
  background: #0ba395;
  border-radius: 2px;
  border-radius: 2px;
  color: #fff;
  box-sizing: border-box;
  cursor: pointer;
  box-sizing: border-box;

  &.replayed {
    background: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(153, 162, 170, 0.5);
    color: rgba(255, 255, 255, 0.7);
    &:hover {
      color: #fff;
    }
  }
}

.player-finish-replay-icon {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}

.player-wrapper,
.link {
  width: 100%;
  height: 100%;
}

.link {
  cursor: pointer;
}

.bannder-slider-icon {
  width: 14px;
  height: 14px;

  display: none;

  &.playing {
    width: 20px;
    height: 20px;
  }
}

.bannder-slider-status {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.banner-fade-enter-active {
  transition: opacity 1s ease;
}

.banner-fade-enter {
  opacity: 0;
}

.link_item {
  height: 550px;
}

.banner_img_wrap {
  height: 100%;
}

@media screen and (max-width: 1438px) {
  .banner-slider-wrapper,
  .banner-slider {
    width: 252px;
  }

  .cheese_banner {
    width: 1070px;
  }

  .banner-content {
    width: 818px;
    height: 460px;
  }

  .player-innerWrapper {
    height: 460px;
  }

  .banner-wrapper {
    padding: 20px 0;
  }

  .banner-slider-wrapper {
    /* padding: 40px 0; */
    height: 460px;
  }

  .banner-item {
    padding: 15px 30px;
    margin: 0;
  }

  .link_item {
    height: 460px;
  }
}
</style>
